import { useMemo } from 'react'

import { PROJECT_PATHS } from 'constants/paths'
import { useProjectsGetById } from 'gql/projects/apollo'
import { useSectionsAll } from 'gql/sections/apollo'
import { usePathParams } from 'routes/hooks'
import { useSectionsRightOrder } from 'utils/project.hooks'

export const useGetSortedSections = () => {
  const { projectId } = usePathParams(PROJECT_PATHS.home)
  const { data: projectData, loading: projectLoading } = useProjectsGetById(projectId, {
    fetchPolicy: 'cache-and-network',
  })
  const { data: sectionsAllData, loading: isSectionsLoading } = useSectionsAll(projectId)

  const sections = useSectionsRightOrder(
    sectionsAllData?.data.sections,
    projectData?.data?.sectionsOrder,
  )
  const firstSection = useMemo(() => sections.find((section) => !section.isChapter), [sections])
  return {
    sections,
    project: projectData?.data,
    loading: projectLoading || isSectionsLoading,
    firstSection,
  }
}
